import React, {Component} from 'react';
import {HashRouter as Router, Switch, Route, Link} from 'react-router-dom';
import {Overlay} from 'vexpo-components';
import FontAwesome from 'react-fontawesome';
import ShowbagPreview from './showbag-preview/showbag-preview';
import BoothReview from './booth-reviewer/booth-review-preview';
import BoothPreview from './booth-preview/booth-preview';
import HallPreview from './hall-preview/hall-preview';
import StagePreview from './stage-preview/stage-preview';
import GiftCardsPreview from './gift-cards-preview/gift-cards-preview';

/** @class Previewer
  * The Previewer component maps the route to an
  * appropriate preview of the expo.
  */
export default class Previewer extends Component {
  /** @method render
    * Renders the component
    */
  render() {
    return (
      <div>
        <Overlay/>
        <Router>
          <Switch>
            <Route path={"/entry/stage"} exact={true} render={() => (
              <StagePreview expoID={this.props.expoID} showID={this.props.showID} location="entry"/>
            )}/>
            <Route path={"/lobby/stage"} exact={true} render={() => (
              <StagePreview expoID={this.props.expoID} showID={this.props.showID} location="lobby"/>
            )}/>
            <Route path={"/showbag"} exact={true} render={() => (
              <ShowbagPreview expoID={this.props.expoID} showID={this.props.showID} />
            )}/>

            <Route path={"/booth-review/:boothID"} render={({match}) => (
              <div>
                <BoothReview expoID={this.props.expoID} showID={this.props.showID} boothID={match.params.boothID} />
                <Route path={"/booth-review/:boothID/contents"} render={({match}) => (
                  <div>
                    <header style={{position: "absolute", zIndex: 10, top: 0, left: 0, width: "100vw", height: "2rem", backgroundColor: "#333d", textAlign: "right"}}>
                      <Link key="hall" to={"/booth-review/" + match.params.boothID} style={{color: "white", padding: "0.5rem", display: "inline-block"}}>
                        <FontAwesome name="flag"/>
                        Back to Hall
                      </Link>
                    </header>
                    <BoothPreview expoID={this.props.expoID} showID={this.props.showID} hallID={"mockup"} boothID={match.params.boothID} />
                  </div>
                )}/>
              </div>
            )}/>

            <Route path={"/hall/:hallID"} render={({match}) => (
              <div>
                <HallPreview expoID={this.props.expoID} showID={this.props.showID} hallID={match.params.hallID}/>
                <Route path={"/hall/:hallID/booth/:boothID"} exact={true} render={({match}) => (
                    <div>
                      <header style={{position: "absolute", zIndex: 10, top: 0, left: 0, width: "100vw", height: "2rem", backgroundColor: "#333d", textAlign: "right"}}>
                        <Link key="hall" to={"/hall/" + match.params.hallID} style={{color: "white", padding: "0.5rem", display: "inline-block"}}>
                          <FontAwesome name="flag"/>
                          Back to Hall
                        </Link>
                      </header>
                      <BoothPreview expoID={this.props.expoID} showID={this.props.showID} hallID={match.params.hallID} boothID={match.params.boothID} />
                    </div>
                )}/>
              </div>
            )}/>
            <Route path={"/booth/:boothID"} render={({match}) => (
              <BoothPreview expoID={this.props.expoID} showID={this.props.showID} boothID={match.params.boothID} />
            )}/>
            <Route path={"/giftCards"} render={({match}) => (
              <GiftCardsPreview expoID={this.props.expoID} showID={this.props.showID} />
            )}/>
          </Switch>
        </Router>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/previewer.js